import * as React from "react";
import { Box, makeStyles } from "@material-ui/core";
import { MUIBlock, themeVariables } from "../MUI";
import { tl } from "../../../utils";
import * as styles from "./styles.scss";

type IProps = {
  link?: string | null;
  className?: string
};

export const SiteFooter = (props: IProps) => {
  const classes = makeStyles({
    logo: {
      color: themeVariables.palette.grey[500],
      "&:hover": {
        color: themeVariables.palette.grey[600],
      },
    },
  })({});

  return (
    <div className={`${styles.wrap} ${props.className}`}>
      <Box className={styles.logowrap} borderTop={themeVariables.borderOuter}>
        <a
          href={props.link || "/"}
          target="_blank"
          className={`${styles.logolink} ${classes.logo}`}
        >
          <div className={styles.logo}>
            <Box component="span" color={themeVariables.palette.primary.main}>
              {tl('АНТИ')}
            </Box>
            {tl('ТРЕНИНГИ')}
          </div>
          <Box className={styles.slogan}>{tl('платформа онлайн-обучения')}</Box>
        </a>
      </Box>
    </div>
  );
};
